import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, MessageSquare } from "lucide-react";
import { SMS_URL } from "@/config";

const links = [
  { to: "/", label: "Accueil" },
  { to: "/accompagnement", label: "Accompagnement" },
  { to: "/a-propos", label: "À propos" },
  { to: "/lieux", label: "Lieux" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header
      data-testid="main-navbar"
      className="sticky top-0 z-50 border-b border-stone-200 bg-bone/80 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-12">
        <Link to="/" className="flex items-center gap-3" data-testid="navbar-logo-link">
          <img
            src="/logo.png"
            alt="Logo Juliette Maquestiau — enfant assis dans une main protectrice"
            data-testid="navbar-logo"
            className="h-11 w-11 rounded-full object-cover ring-1 ring-taupe/50"
          />
          <span className="hidden font-display text-sm tracking-[0.18em] uppercase text-stone-500 sm:block">
            Juliette Maquestiau
          </span>
        </Link>

        <nav className="hidden items-center gap-8 md:flex" data-testid="navbar-desktop-nav">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s|à/g, "-")}`}
              className={({ isActive }) =>
                `font-display text-sm tracking-wide transition-colors hover:text-taupe ${
                  isActive ? "text-taupe" : "text-charcoal"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <a
            href={SMS_URL}
            data-testid="nav-agenda-cta"
            className="inline-flex items-center gap-2 rounded-full bg-taupe px-5 py-2.5 font-display text-sm text-bone transition-colors hover:bg-taupe-dark"
          >
            <MessageSquare size={16} /> Rendez-vous par SMS
          </a>
          <Link
            to="/contact"
            data-testid="nav-contact-cta"
            className="rounded-full border border-taupe px-5 py-2.5 font-display text-sm text-taupe transition-colors hover:bg-taupe hover:text-bone"
          >
            Contact
          </Link>
        </nav>

        <button
          data-testid="navbar-mobile-toggle"
          className="text-charcoal md:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <nav
          data-testid="navbar-mobile-nav"
          className="border-t border-stone-200 bg-bone px-6 pb-6 pt-4 md:hidden"
        >
          <div className="flex flex-col gap-4">
            {[...links, { to: "/contact", label: "Contact" }].map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s|à/g, "-")}`}
                className={`font-display text-base ${
                  location.pathname === l.to ? "text-taupe" : "text-charcoal"
                }`}
              >
                {l.label}
              </NavLink>
            ))}
            <a
              href={SMS_URL}
              data-testid="mobile-nav-agenda-cta"
              className="mt-2 inline-flex w-fit items-center gap-2 rounded-full bg-taupe px-5 py-2.5 font-display text-sm text-bone"
            >
              <MessageSquare size={16} /> Prendre rendez-vous par SMS
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}
